
import Footer from '../components/footer.vue'
import {
SaunaKanbanQuery,
GetLeftUpInfo
} from '../../static/js/api.js'
import querystring from 'vux/src/tools/querystring/index.js'




export default {
name: 'app',
components: {
'pc-footer': Footer,
},
data() {
return {
loading:true,
my:{
name:"***",
company:{
name:"***"
}
},
data: {
GuestFlows: {},
BarConsumeDetails: {},
BarConsumeSummary: {},
ConsumeDetails: {},
ConsumeSummary: {},
GuestPerConsume: {},
HandCardUsed: {},
MemberUsedDetail: {},
MemberUsedSummary: {},
NewMemberDetails: {},
NewMemberSummary: {},
PayModeDetails: {},
PayModeSummary: {
Money:1
},
PrepaidMemberDetails: {},
PrepaidMemberSummary: {},


},
msg: 'Welcome to Your Vue.js App',
nav: [

{
link:'/xs',
name:'销售统计',
img:require('../assets/CRM_icon_dqyy.png'),

},

{
link:'/bt',
name:'吧台统计',
img:require('../assets/CRM_icon_yjb.png'),

}

],
selectedsr:1,
navsr:[

{
id:1,
name:"会员办卡"

},
{
id:2,
name:"会员续费"

}

]
}
},
mounted(){



},
created() {



var that = this



},
methods:{

refresh(){
this.loading=true
var that=this



},

changesr(index){
console.log(index)
this.selectedsr= parseInt(index+1)

}




}

}



// WEBPACK FOOTER //
// ./src/pages/main1.vue